import './Contact.scss';
import Component from './Contact.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
